import axios from "axios";

const formDataSent = async ({ url, data }) => {
    const result = new Promise((resolve) => {
        axios.post(url, data)
            .then((response) => {
                // Handle the response from the server
                resolve(response.data)
            })
            .catch((error) => {
                // Handle any errors
                console.error(error);
            });
    })
    return result;
}

function validateEmail(email) {
    // eslint-disable-next-line
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function validatePassword(password) {
    // At least one upper case English letter, 
    // At least one lower case English letter, 
    // At least one digit, 
    // At least one special character, 
    // Minimum eight in length 
    // eslint-disable-next-line
    var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    return re.test(password);
}

// function inputStyleChange(target, validation) {
//     if (validation) {
//         target.style.outline = "2px solid green";
//     } else {
//         target.style.outline = "2px solid red";
//     }
// }


export { formDataSent, validateEmail, validatePassword };